import React, { useRef, useEffect } from 'react';

interface EntryContentContainerProps {
  children: React.ReactNode;
  className?: string;
  containerRef?: React.RefObject<HTMLDivElement|null>;
}

function EntryContentContainer({ children, className = "", containerRef }: EntryContentContainerProps) {
  const internalRef = useRef<HTMLDivElement>(null);
  const ref = containerRef || internalRef;

  useEffect(() => {
    const handleWheel = (e: any) => {
      if (e.ctrlKey) {
        return;
      }
      if (ref && ref.current) {
        e.preventDefault();
        e.stopPropagation();
        ref.current.scrollTop += e.deltaY;
      }
    };

    if (ref && ref.current) {
      ref.current.addEventListener('wheel', handleWheel, {passive: false});
    }
    return () => {
      if (ref && ref.current) {
        ref.current.removeEventListener('wheel', handleWheel);
      }
    };
  }, [ref, ref.current]);

  return (
    <div
      ref={ref}
      className={`overflow-auto overscroll-contain min-h-0 ${className}`}
    >
      {children}
    </div>
  );
}

export default EntryContentContainer;
